import { BaseClass } from '../base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { DictionaryValue } from './dictionaryValue';

export class Dictionary extends BaseClass {
    code: string;
    description: string;
    values?: DictionaryValue[];

    constructor()
    constructor(
      code: string, description: string)
    constructor(
      code?: string, description?: string) {
        super();
        this.code = code;
        this.description = description;

    }

    static fromObject(object: Dictionary): Dictionary {
        return Object.assign(new Dictionary(), object);
    }

    get display(): string {
        return `${this.description}`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.description], value);
    }
}
